import { Ref, computed } from 'vue';

import { Company } from '@/components/partners/AddPartner/InvitePartnerSearch.vue';

import { FEATURE_FLAG } from '@/constants/feature_flags';
import { useBillingStore, useFeatureFlagStore } from '@/stores';

export default function useActivationTeamCcGate(
  selectedCompany: Ref<Company | null>,
) {
  const featureFlagStore = useFeatureFlagStore();
  const billingStore = useBillingStore();

  const isInviteePaidCustomer = computed(
    () => !!selectedCompany.value?.is_paid_customer,
  );

  const canShowActivationTeamCc = computed(
    () =>
      featureFlagStore.hasFeatureFlag(FEATURE_FLAG.TEMP_ACTIVATION_TEAM_CC) &&
      !billingStore.isFreeTier &&
      !isInviteePaidCustomer.value,
  );

  return { canShowActivationTeamCc };
}
